import {customAxiosBE} from "../config";
import moment from "moment/moment";

export async function getWhiteListReportApi(data) {
    return customAxiosBE.post(`/reports/white-list`, data);
}

export async function getOperatorIncomeApi(data){
    return customAxiosBE.post(`/report/operator-income`, {
        ...data,
        dateFrom: moment(data.dateFrom).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        dateTo: moment(data.dateTo).startOf("day").format("YYYY-MM-DDTHH:mm:ss")
    })
}

export async function getTicketsReportApi(data){
    return customAxiosBE.post(`/report/tickets-report`, data)
}

export async function getCommissionsReportApi(data, signal){
    return customAxiosBE.post(`/report/commission`, {
        ...data
    }, signal)
}

export async function getOperatorSalesReportApi(data) {
    return customAxiosBE.post(`/report/operator-sales`, data);
}

export async function getReportMonthlyPassesApi(data) {
    return customAxiosBE.post(`/report/monthly-passes`, data);
}

export async function getTicketMultiPassSummary(data) {
    return customAxiosBE.post(`/report/ticket-mulit-pass-summary`, data);
}

export async function getCommissionReport(data) {
    return customAxiosBE.post(`/report/commission`, data);
}

export async function getPeronizationRateExists() {
    return customAxiosBE.get(`/report/commission/peronization-rate-exists`);
}

export async function getAllIssuedForAPI() {
    return customAxiosBE.get(`/report/monthly-passes/issued-for`);
}

export async function getInternationalReportApi(data) {
    return customAxiosBE.post(`/report/international`, {
        ...data,
        dateFrom: moment(data.dateFrom).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        dateTo: moment(data.dateTo).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    });
}


